<template>
  <div>
    <h2 class="c-pageTitle">
      {{ $t('components.RequireGmbConnect.title') }}
    </h2>
    <p>{{ $t('components.RequireGmbConnect.notice') }}</p>
    <div class="c-button c-button--left">
      <a
        :href="`/s/companies/${companyUuid}/google_oauth`"
        class="c-button__item c-button__item--primary"
      >
        {{ $t('components.RequireGmbConnect.doConnect') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RequireGmbConnect',
  data() {
    return {
      companyUuid: this.$route.params.company_uuid
    }
  },
}
</script>
